var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9602 2.06665C9.7535 2.06665 8.6735 2.65332 8.00016 3.55332C7.32683 2.65332 6.24683 2.06665 5.04016 2.06665C2.9935 2.06665 1.3335 3.73332 1.3335 5.79332C1.3335 6.58665 1.46016 7.31998 1.68016 7.99998C2.7335 11.3333 5.98016 13.3266 7.58683 13.8733C7.8135 13.9533 8.18683 13.9533 8.4135 13.8733C10.0202 13.3266 13.2668 11.3333 14.3202 7.99998C14.5402 7.31998 14.6668 6.58665 14.6668 5.79332C14.6668 3.73332 13.0068 2.06665 10.9602 2.06665Z",
    fill: "#FF613E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3e187bdd9a4867890a6d7b532ff18dd5.svg";
export { ForwardRef as ReactComponent };